import {NativePermissionStatuses} from 'new-constants/common.constants';
import Platform from '../platform';

function isGeolocationAvailable() {
	return navigator.geolocation;
}

export const isPossibleToRequestLocationPermission = locationPermissionStatus => {
	if (!isGeolocationAvailable()) return false;

	if (
		locationPermissionStatus === NativePermissionStatuses.GRANTED ||
		locationPermissionStatus === NativePermissionStatuses.GRANTED_WHEN_IN_USE
	) {
		return false;
	}

	return true;
};

function requestWebLocationPermission(isRequested, isGranted) {
	if (isRequested && !isGranted) {
		alert(`Location permission is not granted. Please, open ${Platform.isNativeApp ? 'app' : 'website'} settings and allow geolocation usage.`);
		return Promise.reject();
	}

	const errorCodes = {
		PERMISSION_DENIED: 1,
		POSITION_UNAVAILABLE: 2,
		TIMEOUT: 3,
	};

	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			result => {
				resolve(NativePermissionStatuses.GRANTED); //TODO pass status
			},
			result => {
				if (
					result &&
					result.code &&
					(result.code === errorCodes.PERMISSION_DENIED || result.code === errorCodes.POSITION_UNAVAILABLE)
				) {
					resolve(NativePermissionStatuses.DENIED_ALWAYS);
				} else {
					reject();
				}
			}
		);
	});
}

export const requestLocationPermission = function (isRequested, isGranted) {
	return requestWebLocationPermission(isRequested, isGranted);
};

function getMappedWebPermissionStatus(webStatus) {
	if (!navigator.permissions) {
		return null;
	}

	const webStatusMap = {
		granted: NativePermissionStatuses.GRANTED,
		prompt: NativePermissionStatuses.NOT_REQUESTED,
		denied: NativePermissionStatuses.DENIED_ALWAYS,
	};

	return webStatusMap[webStatus];
}

function loadWebLocationPermissionStatus() {
	if (!navigator.permissions) return Promise.reject();

	return new Promise((resolve, reject) => {
		navigator.permissions
			.query({
				name: 'geolocation',
			})
			.then(result => {
				resolve(getMappedWebPermissionStatus(result.state));
			});
	});
}

export const loadLocationPermissionStatus = () => {
	return loadWebLocationPermissionStatus();
};
